import React from "react";
import "../styles/Home.css";
import BandcampIcon from "../assets/img/bandcamp/bandcamp_icon.png";
import FacebookIcon from "../assets/img/facebook/facebook_icon.png";
import AppleMusicIcon from "../assets/img/apple_music/standard.svg";
import SpotifyIcon from "../assets/img/spotify/spotify_icon.png";
import AmazonMusicIcon from "../assets/img/amazon_music/amazon_icon.png";
import YouTubeIcon from "../assets/img/youtube/yt_icon_rgb.png";

const Home = () => {
    return (
        <div className="home">
            <h1>mother sky</h1>
            <p className="tagline">ambient, drones, and soundscapes</p>
            <a href="https://mother-sky.bandcamp.com/music" target="_blank" rel="noreferrer"><img className="bandcampIcon" src={BandcampIcon} alt="bandcamp logo"/></a>
            <a href="https://apple.co/4dBrBkn" target="_blank" rel="noreferrer"><img className="applemusicIcon" src={AppleMusicIcon} alt="apple music icon"/></a>
            <a href="https://open.spotify.com/artist/12VfHoTnxU3QwzqGKiiWLJ" target="_blank" rel="noreferrer"><img className="spotifyIcon" src={SpotifyIcon} alt="spotify music icon" /></a>
            <a href="https://music.amazon.com/artists/B0B1Q8C14P/mother-sky" target="_blank" rel="noreferrer"><img className="amazonmusicIcon" src={AmazonMusicIcon} alt="amazon music icon" /></a>
            <a href="https://www.youtube.com/channel/UCWkKUOMxjC_48cw8y6N8C8A" target="_blank" rel="noreferrer"><img className="youtubeIcon" src={YouTubeIcon} alt="youtube music icon"/></a>
            <a href="https://www.facebook.com/mothersky777/" target="_blank" rel="noreferrer"><img className="facebookIcon" src={FacebookIcon} alt="facebook icon"/></a>
        </div>
    )
}

export default Home;